export enum ActionType {
  DownloadBulkFile,
  ProcessBulkRefund,
  DeleteBulkRefund,
  DownloadSettlementCSV,
  RemoveSettlement,
  InitiateRefund,
  Delete,
}
export interface TableItemProps {
  data: any
  disableItem?: boolean
  onPress?: () => void
  // handleSort?: (sortKey: string) => void
  extendedColumns?: string[]
  from: string
  transactionType?: number
  freezeColumn?: string
  isFreeze?: boolean
  // sortDetails?: { key: string; order: string }
  onAction?: (actionType: ActionType, id: string) => void
  onDownloadFileAction?: (filetype: string, id: string) => void
  onChangeInput?: (rrn: string, value: string) => void
}
